module.exports = __webpack_public_path__ + "img/MiddleSide_right2.aaea7baa.jpg";